<template>
    <div class="d-flex flex-column" id="orders_affinity">
        <v-overlay :value="isPageLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-row ref="headerFilters">
            <data-table-filters v-if="!isMobile"
                name="Encomenda Affinity"
                isAffinity
                :has-active-filters="hasActiveFilters"
                :has-expanded-active-filters="hasExpandedActiveFilters"
                :filters="filters"
                :schema="tSchema(schema)"
                @expand-active-filters="hasExpandedActiveFilters = $event"
                @remove-filter="removeFilter"
                @refresh="refresh"
                @clear-filters="onClearFilters()"
            >
            </data-table-filters>
            <div class="col wrap-title-filters" v-else >
                <filters-dialog
                    name="Encomenda Affinity"
                    isAffinity
                    :has-active-filters="hasActiveFilters"
                    :has-expanded-active-filters="hasExpandedActiveFilters"
                    :filters="filters"
                    :schema="tSchema(schema)"
                    @expand-active-filters="hasExpandedActiveFilters = $event"
                    @remove-filter="removeFilter"
                    @refresh="refresh"
                    @clear-filters="onClearFilters()"
                    >
                </filters-dialog>
            </div>
        </v-row>

        <v-row>
            <v-col cols="12">
                <app-card :contentStyle="'padding: 12px;'" contentIsScrollable="false">
                    <template v-slot:content>
                        <v-row>
                            <v-col cols="12" md="10" sm="11" class="d-flex justify-start pt-0 wrap-myprovet-tabs">
                                <v-tabs id="myprovet-tabs" class="pt-3 pb-2" v-model="selectedTabIndex" start show-arrows next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" height="35px">
                                    <v-tabs-slider color="#154579"></v-tabs-slider>

                                    <template v-for="(item, index) in affinityOrderStore.getTabs">
                                        <v-tab :key="item.tab" :href="'#' + index" class="myprovet-tab-item">
                                            {{ tb(item.tab) }}
                                        </v-tab>
                                    </template>
                                </v-tabs>
                            </v-col>
                            <v-col cols="12" md="2" sm="1" class="px-0 btn-expand">
                                <div class="d-flex justify-end pr-4">
                                    <v-icon  v-if="!showCart" :class="checkProductInCart()?'appbar-icon-button-small btn-bg-color-white dark-blue-color':'appbar-icon-button-small is-disabled'" style="cursor: pointer;margin-right: 20px;" data-cy="hide-totals" @click="showCartProduts">
                                        mdi-cart-outline
                                    </v-icon>
                                    <v-icon  v-if="showCart" class="appbar-icon-button-small btn-bg-color-white dark-blue-color" style="cursor: pointer;margin-right: 20px;" data-cy="hide-totals" @click="hideCartProduts">
                                        mdi-cart
                                    </v-icon>
                                    <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button-small btn-bg-color-white dark-blue-color" style="cursor: pointer" data-cy="hide-totals" @click.stop="isTotalsVisible = !isTotalsVisible">
                                                {{ collapseVerticalIcon }}
                                            </v-icon>
                                        </template>
                                        <span>{{ tb(collapseVerticalTooltipText) }}</span>
                                    </v-tooltip>
                                </div>
                            </v-col>
                        </v-row>

                        <pure-datatable :endpoint="'/api/orders/affinity'" @data-changed="onDataChanges" :queryParams="queryParams" :ready="ready" :customSearch="customSearch" ref="datatable" v-slot:default="{ vOn, vBind,isLoading }">
                            <div>
                                <portal to="v-form-base">
                                    <v-form-base :model="filters" :schema="tSchema(schema)" @input="onFiltersChanged"> </v-form-base>
                                </portal>

                                <v-data-table
                                    class="elevation-1 mx-1 my-1 d-flex flex-column justify-space-between"
                                    :class="{ 'nowrap-headers': $vuetify.breakpoint.width >= 1750,mobile: isMobile }"
                                    :style="`border-radius: 16px; height: ${datatableSize}px;`"
                                    fixed-header
                                    multi-sort
                                    :hide-default-headers="isMobile"
                                    :headers="tHeaders(headers)"
                                    :items="products"
                                    :header-props="headerProps"
                                    @update:options="refresh"
                                    v-on="vOn"
                                    v-bind="vBind"
                                    hide-default-footer
                                    :no-data-text="$t('table.noData')"
                                    :no-results-text="$t('table.noResults')"
                                    :loading="isMobile?isLoading:false"
                                    :loading-text="$t('table.loading')"
                                    :footer-props="{
                                        showFirstLastPage: false,
                                        itemsPerPageOptions: itemsPerPageOptions,
                                        itemsPerPageText: $t('table.itemsPerPage'),
                                    }"
                                >
                                    <template v-if="!isMobile" #[`item.designation`]="scope">
                                        <div class="d-flex justify-start align-center">
                                            <!--<product-image :is-new="!!scope.item.new" :productCode="scope.item.invoice_code" :imageSrc="scope.item.image" width="35" height="35" max-width="35" max-height="35" style="cursor: pointer; position: relative" @click="openProductDetails(scope.item)">
                                            </product-image>-->
                                            <div class="datatable-image"><div class="image-product-list" :style="'background-image: url('+scope.item.thumbnail+');'" @click="openProductDetails(scope.item)"></div></div>
                                            <div class="pl-2 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(scope.item)">
                                                {{ scope.item.designation }}
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.amount_per_package`]="scope">
                                        <div v-if="scope.item.amount_per_package > 0">
                                            {{ scope.item.amount_per_package }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.amount_per_pallet`]="scope">
                                        <div v-if="scope.item.amount_per_pallet > 0">
                                            {{ scope.item.amount_per_pallet }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.pricetable_price`]="scope">
                                        <div class="d-flex justify-start align-center">
                                            <div class="datatable-designation-text" style="cursor: default">
                                                <v-tooltip right open-on-hover content-class="myprovet-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-bind="attrs" v-on="on">
                                                            {{ formatPrice(getIndividualNetValue(scope.item)) }}
                                                        </div>
                                                    </template>

                                                    <span>PVL</span>
                                                </v-tooltip>

                                                <v-tooltip right open-on-hover content-class="myprovet-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-bind="attrs" v-on="on">
                                                            {{ formatPrice(scope.item.msrp) }}
                                                        </div>
                                                    </template>

                                                    <span>PVP</span>
                                                </v-tooltip>
                                            </div>
                                            <product-discounts-icon :inAffinity="true" :inTable="true" v-if="userStore.hasPermissionTo('View discounts icon')" :product="scope.item"></product-discounts-icon>
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.quantity`]="scope">
                                        <div class="d-flex justify-space-between align-center mx-auto">
                                            <quantity-counter
                                                :value="getProductQuantity(scope.item)"
                                                class="justify-space-between mx-auto"
                                                @input="tryUpdateQuantity(scope.item, $event)"
                                                @increment="tryIncrement(scope.item, 1)"
                                                @decrement="tryIncrement(scope.item, -1)"
                                                 :hide-counter="branchStore.cannotPurchase"
                                                >
                                            </quantity-counter>
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.num_packages`]="scope">
                                        {{ getProductNumPackages(scope.item) }}
                                    </template>

                                    <template v-if="!isMobile" #[`item.num_pallets`]="scope">
                                        {{ getProductNumPallets(scope.item) }}
                                    </template>

                                    <template v-if="!isMobile" #[`item.weight`]="scope">
                                        {{ getProductWeight(scope.item) }}
                                    </template>

                                    <template v-if="!isMobile" #[`item.discount1`]="scope">
                                        <span class="red-color" v-if="isInCart(scope.item)">{{ formatDecimal(getProductDiscount(scope.item, 1)) + '%' }}</span>
                                    </template>

                                    <template v-if="!isMobile" #[`item.discount2`]="scope">
                                        <span class="red-color" v-if="isInCart(scope.item)">{{ formatDecimal(getProductDiscount(scope.item, 2)) + '%' }}</span>
                                    </template>

                                    <template v-if="!isMobile" #[`item.discount3`]="scope">
                                        <span class="red-color" v-if="isInCart(scope.item)">{{ formatDecimal(getProductDiscount(scope.item, 3)) + '%' }}</span>
                                    </template>

                                    <template v-if="!isMobile" #[`item.discount4`]="scope">
                                        <span class="red-color" v-if="isInCart(scope.item)">{{ formatDecimal(getProductDiscount(scope.item, 4)) + '%' }}</span>
                                    </template>

                                    <template v-if="!isMobile" #[`item.price`]="scope">
                                        <div>
                                            <v-spacer></v-spacer>

                                            {{ formatPrice(getProductGrossValue(scope.item)) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.discounted_price`]="scope">
                                        <div>
                                            <v-spacer></v-spacer>

                                            {{ formatPrice(getProductNetValue(scope.item)) }}
                                        </div>
                                    </template>

                                    <template v-if="!isMobile" #[`item.actions`]="scope">
                                        <div class="d-flex justify-end d-flex align-center">
                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(scope.item)"> mdi-dots-horizontal-circle-outline </v-icon>
                                        </div>
                                    </template>
                                    <template v-if="isMobile" v-slot:item="{ item, index }">
                                        <tr>
                                            <v-card
                                                elevation="2"
                                                >
                                                <v-row>
                                                    <v-col class="d-flex flex-column col pt-0 pb-0 pr-0 pl-0">
                                                        <v-row class="d-flex align-start pt-0 pb-0">
                                                            <v-col  class="col col-3 pt-0 pb-0 col-image">
                                                                <div class="datatable-image"><div class="image-product-list" :style="'background-image: url('+item.thumbnail+');'" @click="openProductDetails(item)"></div></div>
                                                            </v-col>
                                                            <v-col  class="col col-9 pt-0 pb-0">
                                                                <v-row class="d-flex align-start pt-0 pb-0">
                                                                    <v-col class="col col-12 pt-0 pb-0">
                                                                        <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item)">
                                                                            {{ item.designation }}
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-6 pt-0 pb-0">
                                                                        <div class="pl-0 datatable-lable-text">
                                                                            <div class="label ll">
                                                                                U/CX
                                                                            </div>
                                                                            <div v-if="item.amount_per_package > 0" class="vl">
                                                                                {{ item.amount_per_package }}
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-6 pt-0 pb-0">
                                                                        <div class="pl-0 datatable-lable-text">
                                                                            <div class="label ll">
                                                                                U/PL
                                                                            </div>
                                                                            <div v-if="item.amount_per_pallet > 0" class="vl">
                                                                                {{ item.amount_per_pallet }}
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-6 pt-0 pb-0">
                                                                        <div class="pl-0 datatable-lable-text">

                                                                            <div class="label ll">
                                                                                PVL
                                                                            </div>
                                                                            <div class="price">
                                                                                {{ formatPrice(getIndividualNetValue(item)) }}
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col  class="col col-6 pt-0 pb-0">
                                                                        <div class="pl-0 datatable-lable-text">
                                                                        <div class="label ll">
                                                                                PVP
                                                                            </div>
                                                                            <div class="price">
                                                                            {{ formatPrice(item.msrp) }}
                                                                             <product-discounts-icon :inAffinity="true" :inTable="true" v-if="userStore.hasPermissionTo('View discounts icon')" :product="item"></product-discounts-icon>
                                                                            </div>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col class="col col-12 pt-0 pb-0 stock">

                                                                        <product-additional-info :product="item"> </product-additional-info>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-col  class="col col-12 pt-0 pb-0">
                                                                <v-row class="d-flex align-start pt-0 pb-0">
                                                                    <v-col  class="col col-3 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label ll">
                                                                                    CX
                                                                                </div>
                                                                                <div class="vl">
                                                                                    {{ getProductNumPackages(item) }}
                                                                                </div>
                                                                            </div>
                                                                        </v-col>
                                                                        <v-col  class="col col-3 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label ll">
                                                                                    PL
                                                                                </div>
                                                                                <div class="vl">
                                                                                    {{ getProductNumPallets(item)  }}
                                                                                </div>
                                                                            </div>
                                                                        </v-col>
                                                                        <v-col  class="col col-4 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label ll">
                                                                                    KG
                                                                                </div>
                                                                                <div class="vl">
                                                                                    {{ getProductWeight(item)  }}
                                                                                </div>
                                                                            </div>
                                                                        </v-col>
                                                                    <v-col class="col col-2 pt-0 pb-0">
                                                                        <div class="d-flex justify-end align-center">
                                                                            <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(item)" data-cy="product-details"> mdi-dots-horizontal-circle-outline </v-icon>
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-col  class="col col-12 pt-0 pb-0">
                                                                <v-row class="d-flex align-start pt-0 pb-0">
                                                                        <v-col  class="col col-3 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label ll">
                                                                                    D1
                                                                                </div>
                                                                                <div class="desc"  v-if="isInCart(item)">
                                                                                    <span class="red-color">{{ formatDecimal(getProductDiscount(item, 1)) + '%' }}</span>
                                                                                </div>
                                                                                <div class="desc"  v-else>
                                                                                        <span>-</span>
                                                                                    </div>
                                                                            </div>
                                                                        </v-col>
                                                                        <v-col  class="col col-3 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label ll">
                                                                                    D2
                                                                                </div>
                                                                                <div class="desc"  v-if="isInCart(item)">
                                                                                    <span class="red-color">{{ formatDecimal(getProductDiscount(item, 2)) + '%' }}</span>
                                                                                </div>
                                                                                <div class="desc"  v-else>
                                                                                        <span>-</span>
                                                                                    </div>
                                                                            </div>
                                                                        </v-col>
                                                                        <v-col  class="col col-3 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                    <div class="label ll">
                                                                                            D3
                                                                                        </div>
                                                                                        <div class="desc"  v-if="isInCart(item)">
                                                                                            <span class="red-color">{{ formatDecimal(getProductDiscount(item, 3)) + '%' }}</span>
                                                                                    </div>
                                                                                    <div class="desc"  v-else>
                                                                                        <span>-</span>
                                                                                    </div>
                                                                            </div>
                                                                        </v-col>
                                                                    <v-col class="col col-3 pt-0 pb-0">
                                                                        <div class="pl-0 datatable-lable-text">
                                                                            <div class="label ll">
                                                                                        D4
                                                                                    </div>
                                                                                    <div class="desc"  v-if="isInCart(item)">
                                                                                        <span class="red-color">{{ formatDecimal(getProductDiscount(item, 4)) + '%' }}</span>
                                                                                    </div>
                                                                                    <div class="desc"  v-else>
                                                                                        <span>-</span>
                                                                                    </div>
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-col  class="col col-12 pt-2 pb-0">
                                                                <v-row class="d-flex align-start pt-0 pb-0">
                                                                    <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                                        <div class="col pt-0 pb-0 label">{{ $t('orders.base.quantity') }}</div>
                                                                        <quantity-counter
                                                                            :value="getProductQuantity(item)"
                                                                            class="justify-space-between mx-auto"
                                                                            @input="tryUpdateQuantity(item, $event)"
                                                                            @increment="tryIncrement(item, 1)"
                                                                            @decrement="tryIncrement(item, -1)"
                                                                            :hide-counter="branchStore.cannotPurchase"
                                                                            >
                                                                        </quantity-counter>
                                                                    </v-col>
                                                                    <v-col class="col col-6 pt-0 pb-0 pl-0">
                                                                        <v-col class="col col-12 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label lf">
                                                                                            {{ tb('VALOR BRUTO') }}
                                                                                        </div>
                                                                                        <div class="price lf">
                                                                                            {{ formatPrice(getProductGrossValue(item)) }}
                                                                                        </div>
                                                                            </div>
                                                                        </v-col>
                                                                        <v-col class="col col-12 pt-0 pb-0">
                                                                            <div class="pl-0 datatable-lable-text">
                                                                                <div class="label lf">
                                                                                        {{ tb('VALOR LÍQUIDO') }}
                                                                                        </div>
                                                                                        <div class="price lf">
                                                                                            {{ formatPrice(getProductNetValue(item)) }}
                                                                                        </div>
                                                                            </div>
                                                                        </v-col>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </tr>
                                    </template>
                                    <template v-slot:footer="scope">
                                        <div>
                                            <div class="datatable-footer-border"></div>

                                            <data-table-footer :isMobile="isMobile" :scope="scope" :showExport="false" @updateOptions="refresh" @purchase="validateOrder()" @emptyCart="openEmptyCartConfirmation()" :isLoading="isLoading" :showEmptyAffinityCartButton="true" style="height: fit-content">
                                            </data-table-footer>
                                        </div>
                                    </template>
                                </v-data-table>
                                <v-row>
                                    <v-btn  v-if="isMobile" text outlined class="mt-1 mr-1 myprovet-btn-cancel btn-clear-qty" @click="openEmptyCartConfirmation()" v-html="isMobile ? $t('orders.affinity.clearQtyShort') : $t('orders.affinity.clearQty')"></v-btn>

                                    <v-btn v-if="isMobile" text outlined class="mt-1 myprovet-btn-ok btn-order" @click="validateOrder()" data-cy="datatable-order-button">{{ $t('common.order') }}</v-btn>
                                 </v-row>
                            </div>
                        </pure-datatable>

                        <v-row ref="totalContent" style="min-height: 261px" v-show="isTotalsVisible" data-cy="affinity-total-content" class="affinity-total-content">
                            <v-col cols="12" md="6" sm="12" v-if="isMobile">
                                <affinity-totals :affinityType="filters.enc_type"></affinity-totals>
                            </v-col>
                             <v-col cols="12" md="6" sm="12"  :class="'hidden-sm-only hidden-xs-only'">
                                <v-row v-if="userStore.hasPermissionTo('Can access the additional information when creating an order')">
                                    <v-col cols="12" v-if="branchStore.branch">
                                        <order-additional-info :firstOrderDiscounts="firstOrderDiscounts" :isAffinity="true" :optionsPosition="'bottom'"></order-additional-info>
                                    </v-col>
                                </v-row>
                                <v-spacer v-else style="height: 145px"></v-spacer>

                            </v-col>

                            <v-col cols="12" md="6" sm="12"  v-if="!isMobile">
                                    <affinity-totals :affinityType="filters.enc_type"></affinity-totals>
                            </v-col>
                            <v-col cols="12" md="6" sm="12" :class="'hidden-md-and-up'">
                                <v-row v-if="userStore.hasPermissionTo('Can access the additional information when creating an order')">
                                    <v-col cols="12" v-if="branchStore.branch">
                                        <order-additional-info :firstOrderDiscounts="firstOrderDiscounts" :isAffinity="true" :optionsPosition="'bottom'"></order-additional-info>
                                    </v-col>
                                </v-row>
                                <v-spacer v-else style="height: 145px"></v-spacer>
                            </v-col>
                            <v-col cols="12" md="12" sm="12" >
                                <v-row class="mt-6">
                                        <v-col cols="12" md="6" sm="6">
                                            <v-select v-model="selectedAddress" :items="getBranchAddresses" item-text="address" :label="$t('orders.affinity.deliveryAddress')" :no-data-text="$t('orders.affinity.noAddresses')" prepend-icon="mdi-map-marker-outline" return-object hide-details dense class="address-input pt1">
                                                <template slot="item" slot-scope="data">
                                                    {{ data.item.address }}
                                                </template>
                                            </v-select>
                                        </v-col>

                                        <v-col cols="12" md="6" sm="6">
                                            <v-text-field :maxlength="250" :counter="250" v-model.trim="observation" :label="$t('orders.affinity.observations')" clearable class="affinity-additional-text-input" prepend-icon="mdi-comment-processing-outline" dense></v-text-field>
                                        </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>
                </app-card>
            </v-col>
        </v-row>

        <product-campaign-form
            v-if="isDetailedCampaignDialogOpen"
            :key="selectedProduct.id"
            :isOpen="isDetailedCampaignDialogOpen"
            :product="selectedProduct"
            :campaigns="productCampaigns"
            :account-blocked-message="accountBlockedMessage"
            :currentSearchTerm="null"
            @input="onCloseDetailedCampaignDialog()"
            @input-remove-campaign="tryRemoveCampaign($event)"
            @finished="finishedSelectingCampaign()"
            :parentPage="affinity"
        ></product-campaign-form>

        <app-dialog v-if="isProductDetailsDialogOpen" :isProductDetails="true" :value="isProductDetailsDialogOpen" @input="isProductDetailsDialogOpen = $event" :title="$t('orders.base.productSheet')" width="55vw" :isResponsive="true" :showActions="false">
            <template v-slot:content>
                <product-details parentPage="affinity" :product="selectedProduct" :key="selectedProduct.id" @change-product="selectedProduct = $event" @show-campaigns="onClickProductCampaign"></product-details>
            </template>
        </app-dialog>

        <app-dialog :value="isEmptyCartDialogOpen" @input="isEmptyCartDialogOpen = $event" :title="$t('layout.attention')" width="35vw">
            <template v-slot:content>
                <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.affinity.clearQtyQuestion') }}</p>
            </template>

            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isEmptyCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>

                <v-btn text class="myprovet-btn-ok px-8 btn-clear-qty" @click="clearCart"> {{ $t('orders.affinity.clearQty') }} </v-btn>
            </template>
        </app-dialog>

        <alert-message-dialog :value="isBlockedDialogOpen" @on-cancel="isBlockedDialogOpen = false" width="80vw" :url="'/api/account-blocked'"> </alert-message-dialog>
        <confirmation-dialog :value="isChangeEncTypeConfirmDialogOpen" @onSuccess="goToNewEncType()" @onCancel="stayOnSameEncType()" :title="$t('layout.attention')" :question="$t('orders.affinity.changeTypeQuestion', { type: tb(this.previousEncType) })"> </confirmation-dialog>
        <confirmation-dialog :value="isConfirmDialogOpen" @onSuccess="finishOrder()" @onCancel="isConfirmDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.affinity.confirmQuestion')"> </confirmation-dialog>
        <confirmation-dialog :value="isUpdatePricesDialogOpen" @onSuccess="updatePrices()" @onCancel="isUpdatePricesDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.summary.pricesChanged')"> </confirmation-dialog>
        <confirmation-dialog :value="isUpdateAffinityDiscountsDialogOpen" @onSuccess="updateAffinityDiscounts()" @onCancel="isUpdateAffinityDiscountsDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.affinity.discountsChanged')"> </confirmation-dialog>
        <confirmation-dialog :value="isRemoveCampaignDialogOpen" @onSuccess="acceptedRemoveCampaign()" @onCancel="isRemoveCampaignDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.base.removeCampaignQuestion')"> </confirmation-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { useCategoriesStore } from '@/Stores/categories';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAffinityOrderStore } from '@/Stores/affinityorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import MainLayout from './../../Layouts/MainLayout';
import VFormBase from 'vuetify-form-base';
import PureDatatable from '@arentia/atools/PureDatatable';
import ResizeObserver from 'resize-observer-polyfill';

export default {
    layout: MainLayout,

    components: {
        VFormBase,
        PureDatatable,
    },

    props: {
        model: [Object, Array],
        schema: [Object, Array],
        headers: [Object, Array],
        configAffinityDiscount: Array,
        firstOrderDiscounts: Array,
        affinityListTypes: Array,
        accountBlockedMessage: String,
    },

    data: () => ({
        // contentCardHeight: "71.5vh",
        contentDataTableHeight: '25vh',
        datatableSize: 200,
        resizeObserver: null,
        filters: {},
        queryParams: {},
        fab: false,
        ready: false,
        defaultFiltersLoaded: false,
        hasExpandedActiveFilters: false,
        isBlockedDialogOpen: false,

        selectedProduct: {},

        isDetailedCampaignDialogOpen: false,
        isProductDetailsDialogOpen: false,
        isEmptyCartDialogOpen: false,
        isConfirmDialogOpen: false,
        isChangeEncTypeConfirmDialogOpen: false,
        showCart:false,
        // Shipping conditions
        onAcceptedCallback: null,
        itemsPerPageOptions:[20,50,100],//window.innerWidth<=1024?[20,50,100]:[10,20,50],
        customSearch: {
            designation: `{
                "type": "query-builder-group",
                "query": {
                    "logicalOperator": "any",
                    "children": [
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "designation",
                                "operator": "keywords",
                                "operand": "designation",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "code",
                                "operator": "contains",
                                "operand": "code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "ean",
                                "operator": "contains",
                                "operand": "ean",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "invoice_code",
                                "operator": "contains",
                                "operand": "invoice_code",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "species.description",
                                "operator": "contains",
                                "operand": "species.description",
                                "value": "__designation__"
                            }
                        },
                        {
                            "type": "query-builder-rule",
                            "query": {
                                "rule": "products##presentation",
                                "operator": "contains",
                                "operand": "products##presentation",
                                "value": "__presentation__"
                            }
                        }
                    ]
                }
            }`,
        },

        selectedTabIndex: 0,
        selectedTabName: null,

        isPageLoading: false,
        isLoading: false,

        isTotalsVisible: true,
        collapseVerticalIcon: 'mdi-arrow-collapse-vertical',
        collapseVerticalTooltipText: 'Esconder Totais',
        totalContentHeight: 0,
        affinityListTypesModel: null,

        goToFirstTab: false,
        previousEncType: null,

        finishingOrder: false,

        isUpdatePricesDialogOpen: false,
        updatedProducts: null,

        isUpdateAffinityDiscountsDialogOpen: false,
        updatedAffinityDiscounts: null,
        affinityDiscountsChanged: false,

        isRemoveCampaignDialogOpen: false,

        productCampaigns: [],
        products: [],
        showCart:false,
        cloneCart:null
    }),

    watch: {
        products: {
            handler: function (products) {
                if (products.length > 0) {
                    this.forceSetAffinityDiscounts();
                }
            },
            immediate: true,
        },
        'branchStore.branch': {
            handler: function (branch) {
                this.ready = false;

                if (!branch) return;

                this.queryParams.branch_id = branch.id;

                this.applyDefaultFilters();
            },
            immediate: true,
        },

        'filters.enc_type': {
            handler: function (affinityType) {
                this.$nextTick(() => {
                    if (this.branchStore.branch && !this.isChangeEncTypeConfirmDialogOpen) {
                        if (this.finishingOrder) {
                            this.finishingOrder = false;

                            if (affinityType !== this.previousEncType) {
                                affinityType ? this.getAffinityTabs() : this.applyDefaultFilters();
                            }
                        } else {
                            if (this.checkIfAreProductsInCart()) {
                                this.isChangeEncTypeConfirmDialogOpen = true;
                            } else {
                                affinityType ? this.getAffinityTabs() : this.applyDefaultFilters();
                            }
                        }
                    }
                });
            },
            immediate: true,
        },

        selectedTabIndex: {
            handler: function (index) {
                if (!this.defaultFiltersLoaded) return;
                if (this.affinityOrderStore.getTabs.length === 0) return;
                if (this.isChangeEncTypeConfirmDialogOpen) return;

                let affinityTab = this.affinityOrderStore.getTabByIndex(index);
                if (affinityTab !== undefined) {
                    affinityTab.tab !== 'Geral' ? this.$set(this.filters, 'brand', affinityTab.tab) : this.$set(this.filters, 'brand', '');
                    this.goToFirstTab = false;
                    setTimeout(()=>{
                        this.setFiltersChanged();
                    },0)
                    this.ready = true;

                    const productsAffinity = this.affinityOrderStore.getProducts;
                    const firstOrderDiscount = this.affinityOrderStore.getFirstOrderDiscount?.percentage;
                    this.productsDiscount(productsAffinity, firstOrderDiscount);
                }
                this.selectedTabName = affinityTab?.tab ?? null;
            },
        },

        isTotalsVisible: {
            handler: function (isVisible) {
                if (isVisible) {
                    this.collapseVerticalIcon = 'mdi-arrow-collapse-vertical';
                    this.collapseVerticalTooltipText = 'Esconder Totais';
                } else {
                    this.collapseVerticalIcon = 'mdi-arrow-expand-vertical';
                    this.collapseVerticalTooltipText = 'Mostrar Totais';
                }
            },
            immediate: true,
        },

        'affinityOrderStore.isFirstOrder': {
            handler: function (isFirstOrder) {
                if (!isFirstOrder) {
                    window.EventBus.$emit('recalc-discounts');
                }
            },
            immediate: true,
        },
        isDetailedCampaignDialogOpen: {
            handler: function (value) {
                if (!value) {
                    useNormalOrderStore().clearAllOldCarts(this.userStore.user.id, this.branchStore.branch.id, ['baseCampaigns'],true);
                }
            }
        }
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useCategoriesStore, useNormalOrderStore, useAffinityOrderStore,useAppStore),

        hasActiveFilters() {
            return Object.values(this.filters)
                .filter((x) => x) // ignore null or undefined
                .filter((x) => x !== this.affinityListTypes[0].enc_type) // ignore the default values for this page
                .some((x) => (typeof x === 'string' && x !== '') || (Array.isArray(x) && x.length > 0) || (typeof x === 'object' && Object.keys(x).length > 0));
        },

        getBranchAddresses() {
            return this.branchStore.getDeliveryAddresses;
        },

        selectedAddress: {
            get() {
                return this.affinityOrderStore.getDeliveryAddress === null || this.affinityOrderStore.getDeliveryAddress.address === undefined ? null : this.affinityOrderStore.getDeliveryAddress.address;
            },
            set(address) {
                this.affinityOrderStore.setDeliveryAddress(address);
            },
        },

        observation: {
            get() {
                return this.affinityOrderStore.getObservation === null ? null : this.affinityOrderStore.getObservation;
            },
            set(observation) {
                this.affinityOrderStore.setObservation(observation);
            },
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    mounted() {
        //this.autoHideTotals();
        this.prepareResponsiveBehaviour();

        window.EventBus.$on('apply-products-discount', (productsAffinity, firstOrderDiscount) => {
            this.productsDiscount(productsAffinity, firstOrderDiscount);
        });
        window.EventBus.$on('update:product-search', (e) => {
            //console.log('product-search',e)
            this.setSearchByCamera(e)
        })
        let portrait = window.matchMedia("(orientation: portrait)");
        portrait.addEventListener("change", (e)=> {
                // Do change
                this.refreshDeely()
        })

        window.EventBus.$on('updated-product-stocks', ({ data }) => {
            this.products.forEach((product, index) => {
                const productStock = data.find((p) => p.code == product.code);
                if (productStock && product.has_current_stock != productStock.has_current_stock) {
                    this.$set(this.products[index], 'has_current_stock', productStock.has_current_stock);
                    this.$set(this.selectedProduct, 'has_current_stock', productStock.has_current_stock);
                }
            });
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.computeDatatableSize);
        this.resizeObserver?.unobserve(this.$refs.headerFilters);
        window.EventBus.$off('apply-products-discount');
        window.EventBus.$off('update:product-search');
        window.EventBus.$off('updated-product-stocks');
    },

    methods: {
        getIndividualNetValue(product) {
            const value = this.calculateProductNetValue(product, true);
            return value ?? 0;
        },
        forceSetAffinityDiscounts() {
            const firstOrderDiscount = this.affinityOrderStore.getFirstOrderDiscount?.percentage;
            if(!firstOrderDiscount)return

            this.products.forEach((product) => {
                product.enc_type = this.filters?.enc_type;
            });
            this.productsDiscount(this.products, firstOrderDiscount);
        },
        checkProductInCart(){
           return _.size(this.affinityOrderStore.getProducts)>0?true:false
        },
        hideCartProduts(){
            this.showCart=false
            this.products=this.cloneCart
        },
        showCartProduts(){
          if(_.size(this.affinityOrderStore.getProducts)==0){
            return
          }
          this.showCart=true
          const productsAffinity = this.affinityOrderStore.getProducts;
          const firstOrderDiscount = this.affinityOrderStore.getFirstOrderDiscount?.percentage;
          this.productsDiscount(productsAffinity, firstOrderDiscount);
          this.cloneCart=_.cloneDeep(this.products)
          this.products= this.affinityOrderStore.getProducts
        },
        setSearchByCamera(searchTerm){
            //this.$set(this.model, 'designation', searchTerm);
            this.$set(this.filters, 'designation', searchTerm);
            this.refresh()
        },
        autoHideTotals() {
            // TODO: review when mobile/tablet layouts are being implemented
            let windowHeight = window.innerHeight;
            if (windowHeight < 900) {
                this.isTotalsVisible = false;
            }
        },
        setItemsPorPage(){
            this.itemsPerPageOptions=[20,50,100]//window.innerWidth<=1024?[20,50,100]:[10,20,50]
        },
        refreshDeely(){
            setTimeout(()=>{
                    this.refresh();
                },300)
        },
        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.totalContentHeight = this.$refs.totalContent.getBoundingClientRect().bottom - this.$refs.totalContent.getBoundingClientRect().top ?? 0;

            this.resizeObserver = new ResizeObserver(makeResponsive);
            this.resizeObserver.observe(this.$refs.headerFilters);
            this.resizeObserver.observe(this.$refs.totalContent);

            window.addEventListener('resize', makeResponsive);

            makeResponsive();
        },

        computeDatatableSize() {
            const topElement = this.$refs.headerFilters;

            if (topElement) {
                const topHeight = topElement.getBoundingClientRect().bottom ?? 0;
                let res = window.innerHeight - 387 - topHeight;

                if (!this.isTotalsVisible) {
                    res += this.totalContentHeight - 24;
                }

                this.datatableSize = res;
            }
        },

        removeFilter(filters, index) {
            filters.splice(index, 1);
            this.onFiltersChanged();
        },

        onFiltersChanged() {
            let hasAutoSearch = this.userStore.user?.auto_search_disabled
            if(this.isIOS()){
                if(!hasAutoSearch){
                    this.setFiltersChanged();
                }
            }else{
                this.setFiltersChanged();
            }
        },
        setFiltersChanged(){
            this.refresh();
            window.EventBus.$emit('check-if-should-overflow');
            window.EventBus.$emit('check-if-should-underflow');
        },
        /*autoFiltersOff() {
                this.refresh();
                window.EventBus.$emit('check-if-should-overflow');
                window.EventBus.$emit('check-if-should-underflow');
        },*/
        refresh(options) {
            if (!this.branchStore.branch) return;

            if (!this.checkIfAreProductsInCart()) {
                if (this.previousEncType != this.filters.enc_type) this.goToFirstTab = true;
                this.previousEncType = this.filters.enc_type;

                if (this.goToFirstTab) this.openFirstTab();

                if (this.$refs.datatable) {
                    if (options) {
                       // options.itemsPerPage=20
                        this.$refs.datatable.setLocalOptions(options);
                    }else{
                        options=this.$refs.datatable.localOptions
                        options.itemsPerPage=20;
                        this.$refs.datatable.setLocalOptions(options);
                    }
                    this.$refs.datatable.onChangeQueryBuilder(this.filters, this.schema);
                }
            }
        },

        checkIfAreProductsInCart() {
            // @Note: Check if there are products in the cart for this enc type
            return this.previousEncType !== null && this.previousEncType !== this.filters.enc_type && this.affinityOrderStore.getProductsByEncType(this.previousEncType).length > 0;
        },

        getAffinityTabs() {
            axios
                .get(`/api/orders/affinity-tabs/${this.filters.enc_type}`, {
                    params: {
                        branch_id: this.branchStore.branch.id,
                    },
                })
                .then((response) => {
                    this.affinityOrderStore.setTabs(response.data);
                    this.goToFirstTab = true;
                    this.onFiltersChanged();
                })
                .catch((error) => {
                    console.error(error);
                    this.showError(this.$t('orders.affinity.loadTabsError'));
                });
        },

        openFirstTab() {
            let affinityTab = this.affinityOrderStore.getTabByIndex(0);
            if (affinityTab !== undefined) {
                this.$set(this.model, 'enc_type', this.affinityListTypes[0].enc_type);
                this.$set(this.filters, 'brand', affinityTab.tab === 'Geral' ? '' : affinityTab.tab);
                this.selectedTabIndex = 0;
            }
        },

        applyDefaultFilters() {
            const hasTypesAndTabs = this.affinityListTypes.length > 0 && this.affinityOrderStore.getTabs.length > 0;

            if (hasTypesAndTabs) {
                let affinityTab = this.affinityOrderStore.getTabByIndex(0);
                this.$set(this.model, 'enc_type', this.affinityListTypes[0].enc_type);
                this.$set(this.model, 'brand', affinityTab.tab === 'Geral' ? '' : affinityTab.tab);
                this.selectedTabIndex = 0;
            }

            for (let field in this.model) {
                this.$set(this.filters, field, this.model[field]);
            }

            this.defaultFiltersLoaded = true;

            if (hasTypesAndTabs) {
                this.onFiltersChanged();
            }
        },

        onClearFilters() {
            this.applyDefaultFilters();
            this.hasExpandedActiveFilters = false;

            this.refresh();
        },

        openProductDetails(product) {
            this.selectedProduct = product;
            this.isProductDetailsDialogOpen = true;
        },

        openEmptyCartConfirmation() {
            this.isEmptyCartDialogOpen = true;
        },

        fullClearCart() {
            this.affinityOrderStore.fullClearCartAndNotify(this.showSuccess);
        },

        clearCart() {
            this.affinityOrderStore.clearCartAndNotify(this.filters.brand, this.showSuccess);
            this.isEmptyCartDialogOpen = false;
        },

        isInCart(product) {
            const item = this.affinityOrderStore.getProduct(product.id);
            return item !== undefined;
        },

        getProductQuantity(product) {
            return this.isInCart(product) ? product.quantity : 0;
        },

        getProductWeight(product) {
            const quantity = this.affinityOrderStore.getProductQuantity(product);
            return this.isInCart(product) ? (product.weight > 0 ? parseFloat(quantity * product.weight).toFixed(2) : parseFloat(0).toFixed(2)) : '';
        },

        getProductNumPackages(product) {
            const quantity = this.affinityOrderStore.getProductQuantity(product);
            const packages = this.isInCart(product) ? (product.amount_per_package > 0 ? Math.floor(quantity / product.amount_per_package) : 0) : '';

            this.affinityOrderStore.setProductPackages(product.id, packages);

            return packages;
        },

        getProductNumPallets(product) {
            const quantity = this.affinityOrderStore.getProductQuantity(product);
            const pallets = this.isInCart(product) ? (product.amount_per_pallet > 0 ? Math.floor(quantity / product.amount_per_pallet) : 0) : '';

            this.affinityOrderStore.setProductPallets(product.id, pallets);

            return pallets;
        },

        getProductDiscount(product, discountNumber, forSingleQuantity = false) {
            return this.affinityOrderStore.getProductDiscount(product, discountNumber, forSingleQuantity) ?? 0;
        },

        getProductGrossValue(product, forSingleQuantity = false) {
            let quantity = forSingleQuantity ? 1 : this.affinityOrderStore.getProductQuantity(product);
            return this.isInCart(product) ? quantity * product.price : 0;
        },

        getProductNetValue(product) {
            const value = this.calculateProductNetValue(product);
            return value ?? 0;
        },

        calculateProductNetValue(product, forSingleQuantity = false) {
            let value = forSingleQuantity ? product.price : this.getProductGrossValue(product, forSingleQuantity);

            const discount1 = this.getProductDiscount(product, 1, forSingleQuantity);
            const discount2 = this.getProductDiscount(product, 2, forSingleQuantity);
            const discount3 = this.getProductDiscount(product, 3, forSingleQuantity);
            const discount4 = this.getProductDiscount(product, 4, forSingleQuantity);
            const discount5 = this.getProductDiscount(product, 5, forSingleQuantity);
            const discount6 = this.getProductDiscount(product, 6, forSingleQuantity);

            if (discount1 > 0) {
                value -= value * (discount1 / 100);
            }
            if (discount2 > 0) {
                value -= value * (discount2 / 100);
            }
            if (discount3 > 0) {
                value -= value * (discount3 / 100);
            }
            if (discount4 > 0) {
                value -= value * (discount4 / 100);
            }
            if (discount5 > 0) {
                value -= value * (discount5 / 100);
            }
            if (discount6 > 0) {
                value -= value * (discount6 / 100);
            }

            if (!forSingleQuantity) {
                this.affinityOrderStore.setProductDiscountedValue(product.id, this.formatDecimal(value, 6));
            }

            return value;
        },

        tryIncrement(product, amount) {
            this.increment(product, amount);
        },

        increment(product, amount) {
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            if (!this.isInCart(product)) {
                product.enc_type = this.filters.enc_type;

                if (amount < 0) return;

                product.enc_type = this.filters.enc_type;
                product.quantity = 1;
                this.affinityOrderStore.addProduct(product);
                return;
            }

            if (product.quantity + amount <= 0) {
                // @Note: `amount` can be negative.
                product.quantity = 0;
                this.affinityOrderStore.removeProduct(product.id);
                return;
            }

            this.affinityOrderStore.incrementProductQuantity(product.id, amount);
        },

        tryUpdateQuantity(product, amount) {
            if (amount === null || amount === '') {
                this.affinityOrderStore.removeProduct(product.id);
                return;
            }

            this.onQuantityUpdated(product, amount);
        },

        onQuantityUpdated(product, amount) {
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            const quantity = parseInt(amount);

            if (!this.isInCart(product) && quantity !== 0) {
                product.enc_type = this.filters.enc_type;
                product.quantity = quantity;

                this.affinityOrderStore.addProduct(product);
                return;
            }

            if (this.isInCart(product)) {
                if (quantity === 0) {
                    this.affinityOrderStore.removeProduct(product.id);
                    return;
                }

                this.affinityOrderStore.setProductQuantity(product.id, quantity);
            }
        },

        onDataChanges(value) {
            // If the product is in the cart, we want to change the quantities accordingly.
            for (const [index, product] of value?.data?.entries()) {
                if (this.isInCart(product)) {
                    const item = this.affinityOrderStore.getProduct(product.id);
                    this.$set(value.data, index, item);
                }
            }
            // Update local paginator data so that we can later display the campaigns.
            this.$set(this, 'products', value?.data ?? []);

            const wrapper = this.$refs['datatable']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },
        validateOrder() {
            if (this.affinityOrderStore.getProductCount <= 0) {
                this.showError(this.$t('orders.affinity.emptyCart'));
                return;
            }

            if (this.affinityOrderStore.getDeliveryAddress === null || this.affinityOrderStore.getDeliveryAddress.address === undefined) {
                this.showError(this.$t('orders.cart.deliveryAddressRequired'));
                return;
            }

            //Informação adicional
            if (this.affinityOrderStore.isBudgetRequest && (this.affinityOrderStore.isScheduledOrder || this.affinityOrderStore.isLaboratoryOrder || this.affinityOrderStore.isFirstOrder)) {
                this.showError(this.$t('orders.cart.quoteConflict'));
                return;
            }

            if (this.affinityOrderStore.isScheduledOrder && !this.affinityOrderStore.getScheduledOrderDate) {
                this.showError(this.$t('orders.cart.invalidScheduleDate'));
                return;
            }

            if (this.affinityOrderStore.isFirstOrder) {
                if (!this.affinityOrderStore.getFirstOrderDiscount?.percentage) {
                    this.showError(this.$t('orders.cart.firstOrderDiscountRequired'));
                    return;
                }
            }

            this.isConfirmDialogOpen = true;
        },

        finishOrder() {

            if(this.isPageLoading) return;

            this.isConfirmDialogOpen = false;

            if (this.branchStore.isBlocked) {
                this.isBlockedDialogOpen = true;
                return;
            }

            this.isPageLoading = true;

            const branch = this.branchStore.branch;

            let dataToPost = {
                branch_id: branch.id,
                products: this.affinityOrderStore.getProducts,
                phc_stamp: this.affinityOrderStore.getDeliveryAddress.phc_stamp,
                observation: this.affinityOrderStore.getObservation,
                iva_value: this.shoppingCartIVA(),
                total_gross_value: this.shoppingCartGrossValue(),
                total_discounted_value: this.shoppingCartDiscountedValue(),

                //Additional info
                isBudgetRequest: this.affinityOrderStore.isBudgetRequest,
                isScheduledOrder: this.affinityOrderStore.isScheduledOrder,
                scheduledOrderDate: this.affinityOrderStore.getScheduledOrderDate,
                isLaboratoryOrder: this.affinityOrderStore.isLaboratoryOrder,
                isFirstOrder: this.affinityOrderStore.isFirstOrder,
                firstOrderDiscount: this.affinityOrderStore.getFirstOrderDiscount?.percentage,
            };

            axios
                .post('/api/orders/affinity/create', dataToPost)
                .then(() => {
                    this.isPageLoading = false;
                    this.affinityOrderStore.finishPurchase(this.showSuccess);

                    this.finishingOrder = true;
                    this.onClearFilters();
                    this.getAffinityTabs();
                })
                .catch(this.onStoreFailure);
        },

        onStoreFailure(error) {
            this.isPageLoading = false;
            console.error(error);

            if (error.response?.data?.message === 'user-blocked') {
                window.location.reload();
                return;
            }

            if (error.response?.data?.message === 'branch-blocked') {
                this.isBlockedDialogOpen = true;
                return;
            }

            // The prices are outdated, the user needs to be notified.
            if (error.response?.data?.message === 'invalid-prices') {
                this.updatedProducts = error.response?.data?.products;
                this.isUpdatePricesDialogOpen = true;
                return;
            }

            // The affinity discounts are wrong, the user needs to be notified.
            if (error.response?.data?.message === 'invalid-affinity-discounts') {
                this.updatedAffinityDiscounts = error.response?.data?.products;
                this.isUpdateAffinityDiscountsDialogOpen = true;
                return;
            }

            this.showError(error.response?.data?.message ?? this.$t('orders.summary.processError'));
        },

        updatePrices() {
            if (this.updatedProducts) {
                this.affinityOrderStore.updateProductPrices(this.updatedProducts);
            }

            this.updatedProducts = null;
            this.isUpdatePricesDialogOpen = false;
        },

        updateAffinityDiscounts() {
            if (this.updatedAffinityDiscounts) {
                for (const product of this.updatedAffinityDiscounts) {
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 1, parseFloat(product.discount1).toFixed(3));
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 2, parseFloat(product.discount2).toFixed(3));
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 3, parseFloat(product.discount3).toFixed(3));
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 4, parseFloat(product.discount4).toFixed(3));
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 5, parseFloat(product.discount5).toFixed(3));
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 6, parseFloat(product.discount6).toFixed(3));

                    this.calculateProductNetValue(product);
                }
            }

            this.updatedAffinityDiscounts = null;
            this.isUpdateAffinityDiscountsDialogOpen = false;
            this.affinityDiscountsChanged = true;
        },

        shoppingCartIVA() {
            const fn = (item) => item.quantity * (item.price * (item.vat.tax / 100));
            return this.affinityOrderStore.getProductSum(fn);
        },

        shoppingCartDiscountedValue() {
            const fn = (item) => item.discounted_price;
            return this.affinityOrderStore.getProductSum(fn, 3);
        },

        shoppingCartGrossValue() {
            const fn = (item) => item.price;
            return this.affinityOrderStore.getProductSum(fn);
        },

        goToNewEncType() {
            this.isChangeEncTypeConfirmDialogOpen = false;
            this.fullClearCart();

            this.getAffinityTabs();
        },

        stayOnSameEncType() {
            this.isChangeEncTypeConfirmDialogOpen = false;

            this.goToFirstTab = false;
            this.filters.enc_type = this.previousEncType;
        },

        productsDiscount(products, firstOrderDiscount = 0) {
            if (firstOrderDiscount > 0) return;
            if (this.affinityDiscountsChanged) {
                this.affinityDiscountsChanged = false;
                return;
            }

            this.affinityListTypesModel = this.affinityListTypes.find((listType) => {
                return listType.enc_type == this.filters.enc_type;
            });

            const subtotals = this.affinityOrderStore.getSubTotals;

            products.forEach((product) => {
                if (subtotals.length === 0 || !this.validateAffinityProduct(product)) {
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 1, 0);
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 2, 0);
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 3, 0);
                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 4, 0);
                } else {
                    if (product.enc_type === this.filters.enc_type && this.validateAffinityProduct(product)) {
                        // @Note: Check if branch is VIP
                        if (this.branchStore.branch.vips.length > 0) {
                            this.branchStore.branch.vips.forEach((vip) => {
                                if (vip.brand.toUpperCase() == product.brand.toUpperCase()) {
                                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 1, this.isNotUndefinedOrNull(vip.discount1) ? parseFloat(vip.discount1).toFixed(3) : this.calcDiscount1(product), product);
                                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 2, this.isNotUndefinedOrNull(vip.discount2) ? parseFloat(vip.discount2).toFixed(3) : this.calcDiscount2(product), product);
                                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 3, this.isNotUndefinedOrNull(vip.discount3) ? parseFloat(vip.discount3).toFixed(3) : this.calcDiscount3(product), product);
                                    this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 4, this.isNotUndefinedOrNull(vip.discount4) ? parseFloat(vip.discount4).toFixed(3) : this.calcDiscount4(product), product);
                                }
                            });
                        } else {
                            this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 1, this.calcDiscount1(product));
                            this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 2, this.calcDiscount2(product));
                            this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 3, this.calcDiscount3(product));
                            this.affinityOrderStore.applyShoppingCartItemDiscount(product.id, 4, this.calcDiscount4(product));
                        }
                    }
                }

                this.calculateProductNetValue(product);
            });
        },

        validateAffinityProduct(product) {
            return this.isNotUndefinedOrNull(this.affinityListTypesModel.enc_type) && this.isNotUndefinedOrNull(product.brand);
        },

        isNotUndefinedOrNull(value) {
            return value !== undefined && value !== null;
        },

        calcDiscount1(product) {
            let discount1 = product.discount_1??0
            if(discount1>0){
                return this.formatDecimal(product.discount_1, 3);
            }
            let discount = 0;
            let configDiscount = this.configAffinityDiscount.filter(function (config) {
                return config.name == 'Desconto 1';
            });

            const subtotals = this.affinityOrderStore.getSubTotals;

            for (let i = 0; i < configDiscount.length; i++) {
                const config = configDiscount[i];

                if (this.isNotUndefinedOrNull(config.brand)) {
                    if (product.quantity > 0 && product.brand.toUpperCase() === config.brand.toUpperCase()) {
                        if (config.enc_type === 'LOJAS' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Brand Package') {
                                let totalBrandPackages = subtotals.find((item) => item.name.toUpperCase() == product.brand.toUpperCase())?.numPackages ?? 0;

                                if (totalBrandPackages >= config.min_amount && totalBrandPackages <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (totalBrandPackages >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            } else if (config.amount_type === 'Product Quantity') {
                                if (product.quantity >= config.min_amount && product.quantity <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (product.quantity >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        } else if (config.enc_type === 'REVENDA' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Brand Package') {
                                let totalBrandPackages = subtotals.find((item) => item.name.toUpperCase() == product.brand.toUpperCase())?.numPackages ?? 0;

                                if (totalBrandPackages >= config.min_amount && totalBrandPackages <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (totalBrandPackages >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            } else if (config.amount_type === 'Product Package') {
                                if (product.packages >= config.min_amount && product.packages <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (product.packages >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return this.formatDecimal(discount, 3);
        },

        calcDiscount2(product) {

            let discount2 = product.discount_2??0
            if(discount2>0){
                return this.formatDecimal(product.discount_2, 3);
            }
            let discount = 0;
            let configDiscount = this.configAffinityDiscount.filter(function (config) {
                return config.name == 'Desconto 2';
            });

            for (let i = 0; i < configDiscount.length; i++) {
                const config = configDiscount[i];

                if (this.isNotUndefinedOrNull(config.brand)) {
                    if (product.quantity > 0 && product.brand.toUpperCase() === config.brand.toUpperCase()) {
                        if (config.enc_type === 'LOJAS' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Product Pallet') {
                                if (product.pallets >= config.min_amount && product.pallets <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (product.pallets >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        } else if (config.enc_type === 'REVENDA' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Product Quantity') {
                                if (product.quantity >= config.min_amount && product.quantity <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (product.quantity >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return this.formatDecimal(discount, 3);
        },

        calcDiscount3(product) {
            let discount3 = product.discount_3??0
            if(discount3>0){
                return this.formatDecimal(product.discount_3, 3);
            }
            let discount = 0;
            let configDiscount = this.configAffinityDiscount.filter(function (config) {
                return config.name == 'Desconto 3';
            });

            const subtotals = this.affinityOrderStore.getSubTotals;

            for (let i = 0; i < configDiscount.length; i++) {
                const config = configDiscount[i];

                if (this.isNotUndefinedOrNull(config.brand)) {
                    if (product.quantity > 0 && product.brand.toUpperCase() === config.brand.toUpperCase()) {
                        if (config.enc_type === 'LOJAS' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Brand Pallet') {
                                let totalBrandPallets = 0;
                                let brands = [...new Set(configDiscount.filter((config) => config.amount_type === 'Brand Pallet').map((config) => config.brand))];

                                for (let j = 0; j < brands.length; j++) {
                                    let brand = subtotals.find((item) => item.name.toUpperCase() == brands[j].toUpperCase());
                                    if (brand !== undefined) {
                                        totalBrandPallets += brand.numPallets;
                                    }
                                }

                                if (totalBrandPallets >= config.min_amount && totalBrandPallets <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (totalBrandPallets >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        } else if (config.enc_type === 'REVENDA' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Product Pallet') {
                                if (product.pallets >= config.min_amount && product.pallets <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (product.pallets >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return this.formatDecimal(discount, 3);
        },

        calcDiscount4(product) {
            let discount4 = product.discount_4??0
            if(discount4>0){
                return this.formatDecimal(product.discount_4, 3);
            }
            let discount = 0;
            let configDiscount = this.configAffinityDiscount.filter(function (config) {
                return config.name == 'Desconto 4';
            });

            const subtotals = this.affinityOrderStore.getSubTotals;

            for (let i = 0; i < configDiscount.length; i++) {
                const config = configDiscount[i];

                if (this.isNotUndefinedOrNull(config.brand)) {
                    if (product.quantity > 0 && product.brand.toUpperCase() === config.brand.toUpperCase()) {
                        if (config.enc_type === 'REVENDA' && config.enc_type === this.affinityListTypesModel.enc_type) {
                            if (config.amount_type === 'Brand Pallet') {
                                let totalBrandPallets = 0;
                                let brands = [...new Set(configDiscount.filter((config) => config.amount_type === 'Brand Pallet').map((config) => config.brand))];

                                for (let j = 0; j < brands.length; j++) {
                                    let brand = subtotals.find((item) => item.name.toUpperCase() == brands[j].toUpperCase());
                                    if (brand !== undefined) {
                                        totalBrandPallets += brand.numPallets;
                                    }
                                }

                                if (totalBrandPallets >= config.min_amount && totalBrandPallets <= config.max_amount) {
                                    discount = config.discount;
                                    break;
                                } else {
                                    if (totalBrandPallets >= config.min_amount && config.max_amount === null) {
                                        discount = config.discount;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return this.formatDecimal(discount, 3);
        },

        onClickProductCampaign(product) {
            this.selectedProduct = product;
            this.getCampaigns();
        },

        getCampaigns() {
            this.isPageLoading = true;

            axios
                .get('/api/campaigns', {
                    params: {
                        reference: this.selectedProduct.code,
                        branch_id: this.branchStore.branch?.id,
                        campaign_id: this.selectedProduct.campaign_id,
                    },
                })
                .then((response) => {
                    this.isPageLoading = false;
                    this.productCampaigns = response.data;

                    if (this.productCampaigns.length == 0) {
                        this.showError(this.$t('orders.base.campaignsUnavailable'));
                    } else {
                        this.normalOrderStore.restoreBaseCampaigns(this.productCampaigns);
                        this.isDetailedCampaignDialogOpen = true;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.isPageLoading = false;
                });
        },

        onCloseDetailedCampaignDialog() {
            this.isDetailedCampaignDialogOpen = false;
        },

        finishedSelectingCampaign() {
            this.isDetailedCampaignDialogOpen = false;
        },

        tryRemoveCampaign(product, isIncrement = null) {
            this.selectedProduct = product;
            const campaign = this.normalOrderStore.getCampaignForOriginatingProduct(product.originating_product_id);
            const fulfilledRequirements = [];

            for (const requirement of campaign.requirements) {
                if (!requirement.product.quantity) continue; // didn't buy in to this requirement.
                fulfilledRequirements.push(requirement);
            }

            if (campaign.amount_of_requirements_needed > 0 && fulfilledRequirements.length > campaign.amount_of_requirements_needed) {
                if (isIncrement === null) product.quantity = 0;
                this.normalOrderStore.changeCampaignQuantityOnExisting(product.campaign_unique_id, product.index, isIncrement, null);
            } else {
                this.isRemoveCampaignDialogOpen = true;
            }
        },

        acceptedRemoveCampaign() {
            if (this.isDetailedCampaignDialogOpen) this.isDetailedCampaignDialogOpen = false;
            this.remove(this.selectedProduct);
        },

        remove(item) {
            if ('campaign_id' in item) {
                this.normalOrderStore.removeCampaign(item.campaign_unique_id, item.id);
                this.isRemoveCampaignDialogOpen = false;
            } else {
                this.normalOrderStore.removeProduct(item.id);
                this.isConfirmDialogOpen = false;
            }
        },
    },
};
</script>

<style>
.v-text-field {
    margin-top: 0 !important;
}

.v-text-field input {
    padding: 4px 0 !important;
    margin-top: 0 !important;
}
#orders_affinity .v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
#orders_affinity .v-data-table>.v-data-table__wrapper>table>tbody>tr>th,
#orders_affinity .v-data-table>.v-data-table__wrapper>table>tfoot>tr>td,
#orders_affinity .v-data-table>.v-data-table__wrapper>table>tfoot>tr>th,
#orders_affinity .v-data-table>.v-data-table__wrapper>table>thead>tr>td,
#orders_affinity .v-data-table>.v-data-table__wrapper>table>thead>tr>th{
    padding: 0 6px;
}
#orders_affinity .v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
    height: 42px!important;
}
#orders_affinity .v-data-table>.v-data-table__wrapper>table>tbody>tr>td.tr-design {
    padding: 0px;
}
#orders_affinity .v-image__image--cover{
  background-size: contain;
}
#orders_affinity .v-image{
   height: 42px!important;
   max-height: 42px!important;
   max-width: 42px!important;
   width: 42px!important;
}
#orders_affinity .datatable-image {

    margin-right: 0;
    margin-left: 10px;
    min-width: 35px;
    min-height: 35px;
}
</style>
